export enum CASHIER_TYPES {
    TRANSACTION_DEPOSIT = "deposit",
    HTTTRANSACTION_WITHDRAWAL = "withdraw",
}

export enum feesTypes {
    FEES_TYPE_NONE = "none",
    FEES_TYPE_ABSOLUTE = "absolute",
    FEES_TYPE_PERCENTAGE = "percentage",
}

export enum PAYMENT_METHODS {
     CREDITCARD= "CREDITCARD",
     BRITEPLAY = "BRITEPLAY",
     PLIXPAY = "PLIXPAY",
     ARI_10 = "ARI10",
     MIFINITY="MIFINITY"
}

export interface cashierMethod{
    name:string,
    feeAmount:string,
    feeType:string,
    maxLimit:string,
    minLimit:string,
    isThirdparty:boolean,
    logoUrl:string,
    providerType:string,
    service:string,
    updatedTime:string
}

// export const logoExtension = '.svg';
export const LOGO_EXTENSION = '.svg';
export const CASHIER_METHODS_NAME_EXTENSION = '-HOSTED';
export const CASHIER_METHODS_SELECT_MIN_COUNT = 4;


export const USER_DEFAULT_CURRENCY_SYMBOL = "€";
export const USER_DEFAULT_CURRENCY = "EUR"

export const CUSTOM_AMOUNT_ONE = '100';
export const CUSTOM_AMOUNT_TWO = '200';
export const CUSTOM_AMOUNT_THREE = '300';

export const DEFAULT_MIN_LIMIT = '0';
export const DEFAULT_MAX_LIMIT = '99999';
//1000 = 1s
export const TIME_DELAY_FOR_DEPOSIT_NOTIFICATION = 5000;

//plix pay config
export const DEPOSIT_TYPE_I_FRAME = "deposit-cashier";

export const methodConfig = 
    {
        "CREDITCARD":{
            "inputs":[
                { type: 'text',id:'fullName',name: 'fullName', label: 'creditCard.fullName',value: '',required: true,isMultiRow:false, className:'', minLength:0,maxLength:0,minWidth:0},
                { type: 'text',id:'cardNumber',name: 'cardNumber', label: 'creditCard.cardNumber',value: '',required: true,isMultiRow:false,className:'icn-input icn-card-num',minLength:8,maxLength:20,minWidth:0},
                { type: 'text',id:'cardExpiry',name: 'cardExpiry', label: 'creditCard.cardExpiry',value: '',required: true,isMultiRow:true,className:'icn-input icn-card-num inline-field-expiry',minLength:5,maxLength:5,minWidth:480},
                { type: 'number',id:'cardCvv',name: 'cardCvv', label: 'creditCard.cardCvv',value: '',required: true,isMultiRow:true,className:'icn-input icn-card-cvv inline-field-cvv inputWithoutDecimal',minLength:3,maxLength:3,minWidth:480}
            ],
            "oneLineFields":['cardExpiry','cardCvv']
        },
        "BRITEPLAY":{},
        "PLIXPAY":{},
        "ARI10":{},
        "MIFINITY":{}
    }


export const acceptedCreditCardsRegex =  [
    {
        mastercard:
      /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
        cardLength:[],
        cvvLength:[3]
    },
    {
        amex: /^3[47][0-9]{13}$/,
        cardLength:[],
        cvvLength:[]
    },
    {
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        cardLength:[],
        cvvLength:[]
    },
    {
        discover:
      /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
        cardLength:[],
        cvvLength:[]
    },
    {
        jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
        cardLength:[],
        cvvLength:[]
    },
    {
        diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        cardLength:[],
        cvvLength:[]
    },
]

export const CASHIER_PAGES ={
 I_FRAME_PAGE:'i-frame-page',
 TRANSACTION_STATUS_PAGE:'transaction-status-page',
 PAYEMENT_DETAILS_PAGE:'payment-details-page',
}

export const britePlayScript = 'https://websdk.britepayments.io/v1/client.js';
export const BRITEPLAY_REQUEST_MIN_LOOP_COUNT = 40;



export const cashierPreMethods = {
    'BRITEPLAY':{
        feeAmount:"0",
        feesType:"none",
        isThirdparty:false,
        logoUrl:"https://dev-buumi-api.en-crm-secure.com/uploads/media/BMI/cashier_logos/BRITEPLAY.png",
        maxAmount:0,
        minAmount:0,
        name:"BRITEPLAY",
        updatedTime:"0"
    }
}

export const paymentMethods =[
    { name:'PLIXPAY', isNewWindow:false},
    { name:'ARI10', isNewWindow:true}
]